// @ts-nocheck
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import { getMediaQuery } from "@toolkit/Framework/Common/Utilities/mediaQueries";
import React from "react";
import styled from "styled-components";

const containerMediaQuery = getMediaQuery({ option: "only", first: true, min: 0, max: 480, last: false });
const Container = styled.div<InjectableCss>`
    padding: 2rem;
    margin: 0 auto;
    min-height: 50vh;
    ${containerMediaQuery} {
        padding-inline: 0.5rem;
        min-height: 70vh;
    }
    {injectableCss}
`;
interface Props {
    children: React.ReactNode;
}
const ReportContainer: React.FC<Props> = ({ children }) => {
    return <Container>{children}</Container>;
};

export default ReportContainer;
